import { styled } from '@mui/material/styles';
import { Dialog, Button, Box } from "@mui/material";

export const StyledDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialog-paper': {
        backgroundColor: '#1e1e1e',
        color: '#fff',
        borderRadius: '16px',
        minWidth: '500px',
        [theme.breakpoints.down('sm')]: {
            minWidth: '90%',
            margin: '16px',
        },
    },
}));

export const ActionButtons = styled(Box)({
    display: 'flex',
    gap: '1rem',
    marginTop: '0.5rem',
    '& button': {
        flex: 1,
        padding: '0.75rem',
        borderRadius: '8px',
        fontWeight: 600,
        textTransform: 'none',
        fontSize: '0.9rem',
    },
});

export const EditButton = styled(Button)({
    backgroundColor: '#ff9800',
    color: '#fff',
    '&:hover': {
        backgroundColor: '#f57c00',
        transform: 'translateY(-2px)',
    },
    '&:disabled': {
        backgroundColor: '#ff980080',
    },
});

export const ConfirmButton = styled(Button)({
    backgroundColor: '#7367F0',
    color: '#fff',
    '&:hover': {
        backgroundColor: '#5e50b0',
        transform: 'translateY(-2px)',
    },
    '&:disabled': {
        backgroundColor: '#7367F080',
    },
});

export const DownloadButton = styled(Button)({
    backgroundColor: '#4caf50',
    color: '#fff',
    '&:hover': {
        backgroundColor: '#45a049',
        transform: 'translateY(-2px)',
    },
    '&:disabled': {
        backgroundColor: '#4caf5080',
    },
});